import { render, staticRenderFns } from "./ElectricityData.vue?vue&type=template&id=b56d9b22&scoped=true"
import script from "./ElectricityData.vue?vue&type=script&lang=js"
export * from "./ElectricityData.vue?vue&type=script&lang=js"
import style0 from "./ElectricityData.vue?vue&type=style&index=0&id=b56d9b22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56d9b22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b56d9b22')) {
      api.createRecord('b56d9b22', component.options)
    } else {
      api.reload('b56d9b22', component.options)
    }
    module.hot.accept("./ElectricityData.vue?vue&type=template&id=b56d9b22&scoped=true", function () {
      api.rerender('b56d9b22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Basics/BasicsEnergyData/ElectricityData/ElectricityData.vue"
export default component.exports